export default {
  methods: {
    hasNoEmptyFields(fields = null, form = null, associations = {}) {
      let myFields = fields || Object.keys(this.form.originalData);
      let myForm = form || this.form;
      let errors = 0;
      myFields.forEach((f) => {
        if (myForm[f] === "") {
          this.message.fail[f] = `O campo '${(associations[f])? associations[f] : f}' é obrigatório.`
          errors++;
        } else {
          this.message.fail[f] = '';
        }
      });
      return (!errors);
    },
  }
}
